import '../paedml-modal.tag'
import '../paedml-form-input.tag'
import '../paedml-icon.tag'

<paedml-modal-status-mdm>
  <paedml-modal prefix={opts.prefix} 
                heading={opts.heading} 
                opname={opts.opname} 
                edit={opts.edit} 
                selectedrowsfunc={opts.selectedrowsfunc} 
                idcol={opts.idcol} 
                idtextcol={opts.idtextcol}
                submitfunc={submitHandler}>
  
    <yield to="fields">

      <div if={parent.loading} class="d-flex justify-content-center pt-5 pb-5">
        <p class="my-auto">Der Status der MDM Umgebung wird aktualisiert...</p>
        <div class="sk-wave">
          <div class="sk-rect sk-rect1"></div>
          <div class="sk-rect sk-rect2"></div>
          <div class="sk-rect sk-rect3"></div>
          <div class="sk-rect sk-rect4"></div>
          <div class="sk-rect sk-rect5"></div>
        </div>
      </div>
  
    <div if={!parent.loading}>
      <div class="row">
          <div class="col-md-12">
              <paedml-form-input name="externalServerUrl" label="MDM Server URL" readonly  />
            </div>
        </div>
      </virtual>

      <virtual if={!parent.loading && !parent.data.isRunning}>
        <div class="p-2"></div>
        <div class="mt-2 mr-1 p-2 border border-danger">
          <span><paedml-icon icon="fas-exclamation-triangle" simple="danger" />
            Die MDM Umgebung ist <strong class="text-danger pl-1 pt-2">nicht erreichbar.</strong>
          </span>
        </div>
        <div class="p-1"></div>
      </virtual>

      <virtual if={!parent.loading && parent.data.isRunning}>
        <div class="p-2"></div>
        <div class="mt-2 mr-1 p-2 border border-success">
          <span><paedml-icon icon="fas-check-circle" simple="success" />
            Die MDM Umgebung ist <strong class="text-success pl-1 pt-2">online.</strong>
          </span>
        </div>
        <div class="p-1"></div>

      </virtual>
    </yield>
  </paedml-modal>
    
    <script>
      import store from '../../store'
      import API from '../../api'

      this.opname = this.opts.opname

        this.data = {
            isRunning: false,
            externalServerUrl: "",
            licenseModelName: "UNBEKANNT"
        }
      this.api = this.opts.api

      this.getStatus = () => {
        this.loading = true
        API.mdm.onlineStatus().then(rsp => {
          const [data, status] = rsp
          this.loading = false

          this.data.isRunning = data.isRunning
          this.data.externalServerUrl = data.externalServerUrl
          this.update()
        
          $('input[name=externalServerUrl]', this.root).val(this.data.externalServerUrl)
        })
      }

      this.on('dataRequested', () => {
        this.getStatus()
      })

      this.submitHandler = formData => {
          return Promise.resolve('OK')
      }
    </script>
</paedml-modal-status-mdm>
